import { render, staticRenderFns } from "./softwareLis.vue?vue&type=template&id=235f05aa&scoped=true&"
import script from "./softwareLis.vue?vue&type=script&lang=ts&"
export * from "./softwareLis.vue?vue&type=script&lang=ts&"
import style0 from "./softwareLis.vue?vue&type=style&index=0&id=235f05aa&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235f05aa",
  null
  
)

export default component.exports